import { PureComponent } from 'react';
import { getAuthUrl } from '../../config';

class Exit extends PureComponent {
  componentDidMount() {
    if (window.location.origin.includes('s1')) {
      window.location.href = 'https://s1.stage.offerrum.com';
    } else {
      window.location.href = getAuthUrl();
    }
  }

  render() {
    return null;
  }
}

export default Exit;
